import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { CornerBrackets } from './CornerBrackets';

export const Showreel = () => {
  const { t } = useTranslation();

  return (
    <section
      id="showreel"
      className="relative py-40 lg:py-56 overflow-hidden bg-background">



      <div className="container mx-auto px-6 lg:px-16 relative z-10 flex flex-col items-center text-center">
        <div className="relative py-8 px-10">
          <CornerBrackets size={70} topRightClassName="-top-2 -right-2" bottomLeftClassName="-bottom-2 -left-2" />
          <motion.h2
            className="text-lg md:text-2xl lg:text-3xl uppercase leading-snug tracking-tight max-w-5xl"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1, delay: 0.2 }}>
            <span className="block text-foreground font-normal">{t('showreel.line1')}</span>
            <span className="block text-gradient mt-3 font-black">{t('showreel.line2')}</span>
          </motion.h2>
        </div>
      </div>
    </section>
  );
};
